import { registerDecorators as _registerDecorators, LightningElement, registerComponent as _registerComponent } from "lwc";
import _tmpl from "./suggestionOption.html";
class SuggestionOption extends LightningElement {
  constructor(...args) {
    super(...args);
    this.suggestion = void 0;
  }
  renderedCallback() {
    const suggestionText = this.template.querySelector('.suggestion-text');
    if (suggestionText) {
      // eslint-disable-next-line @lwc/lwc/no-inner-html
      suggestionText.innerHTML = this.textToDisplay();
    }
  }
  textToDisplay() {
    return `“${this.transformedKeyword()}”`;
  }
  transformedKeyword() {
    return this.suggestion?.highlighted?.replace(/{/g, '<mark>').replace(/}/g, '</mark>').replace(/[)([\]]/g, '') || this.suggestion.suggestedKeyword;
  }
  /*LWC compiler v7.1.3*/
}
_registerDecorators(SuggestionOption, {
  publicProps: {
    suggestion: {
      config: 0
    }
  }
});
const __lwc_component_class_internal = _registerComponent(SuggestionOption, {
  tmpl: _tmpl,
  sel: "",
  apiVersion: 62
});
export default __lwc_component_class_internal;